// extracted by mini-css-extract-plugin
module.exports = {"label-container":"_4e5f713ae4--label-container--vskUj"};